export default {
  title: 'Impressum',
  subtitle: 'Das Impressum erscheint erst nach dem Speichern in der Fußzeile Ihres Online-Shops und Ihrer Website.',
  card_title: 'Impressum',
  placeholder: 'Geben Sie Ihre Impressumsangaben ein',
  status: {
    saved: 'Gespeichert',
    not_shown: 'Noch nicht in Ihrem Shop oder auf Ihrer Website sichtbar',
    unsaved: 'Ungespeicherte Änderungen — Shop und Website zeigen die zuletzt gespeicherte Fassung',
  },
  save: 'Speichern',
  retry: 'Erneut versuchen',
  preview: {
    title: 'Vorschau der Fußzeile (Shop und Website)',
    terms: 'AGB',
    privacy: 'Datenschutz',
    cookies: 'Cookies',
    imprint: 'Impressum',
  },
  toasts: {
    saved: 'Impressum gespeichert',
    save_failed: 'Das Impressum konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    load_failed: 'Das Impressum konnte nicht geladen werden. Bitte laden Sie die Seite neu.',
  },
};
